// WizardNameSection — US-125 (campaign name).
//
// Extracted verbatim from CreateWizard's inline "Section 1 — name" block.

import { useT } from '@barel/i18n';
import { Card, FieldAssembly, Input } from '@barel/ui';

export interface WizardNameSectionProps {
  name: string;
  onNameChange: (next: string) => void;
}

export function WizardNameSection({ name, onNameChange }: WizardNameSectionProps) {
  const t = useT('campaigns');
  return (
    <Card padding="lg" radius="2xl" data-testid="wizard-section-name">
      <div className="mb-3">
        <strong className="text-primary text-sm">{t('create.sectionName.title')}</strong>
        <p className="text-tertiary text-xs mt-1">{t('create.sectionName.sub')}</p>
      </div>
      <FieldAssembly label={t('create.sectionName.label')}>
        <Input
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={t('create.sectionName.placeholder') as string}
          data-testid="wizard-name"
        />
      </FieldAssembly>
    </Card>
  );
}
